/**
 * Format a cargo weight (stored in kilograms) for display.
 *
 * Small loads stay in kilograms (`"20 kg"`); loads of 1,000 kg or more switch
 * to tonnes with up to two decimals and no trailing zeros (`"24 t"`, `"1.5 t"`).
 *
 * @param kg - Weight in whole kilograms.
 * @returns Human-readable weight string with unit suffix.
 */
export function formatWeight(kg: number): string {
  if (kg < 1000) return `${kg.toLocaleString()} kg`
  const tons = kg / 1000
  return `${Number(tons.toFixed(2)).toLocaleString()} t`
}
